//libraries
import { IMapOfString } from 'global';
import logger from 'shared/logger';

//def
interface IErrorParams extends Error {
  requestId?: string;
  URL?: string;
}
interface IResponseParams extends Response {
  requestId?: string;
}

export const captureRequest = (req: any) => {
  const requestId = req.headers['cf-ray'] || req.headers['ak-ray'] || '';
  req.requestId = requestId;
  logger.info({ req: req });
  return requestId;
};

export const captureResponse = (res: IResponseParams, requestId: string) => {
  res.requestId = requestId;
  logger.info({ res: res });
};

export const captureError = (err: IErrorParams, requestId: string, url: string) => {
  err.requestId = requestId;
  err.URL = url;
  logger.error({ err: err });
};

export const captureResponseError = (res: Response, requestId: string) => {
  const err: IMapOfString = {};
  err.requestId = requestId;
  err.url = res.url;
  err.statusCode = res.status.toString();
  logger.error({ err: err });
};
